import { Request } from './Request';
export class Server {
    constructor(host) {
        this.middlewares = [];
        /**
         * When decoding the version headers of the response will be used if they are present.
         */
        this.versionHeaders = ['X-Version'];
        this.host = host;
    }
    setVersionHeaders(headers) {
        this.versionHeaders = headers;
    }
    /**
     * Build an internal request. Start it manually.
     * Usefull if you need the reference to the request object in order to cancel it later.
     */
    build(request) {
        const r = new Request(this, request);
        r.middlewares.push(...this.middlewares);
        return r;
    }
    /**
     * Build an internal request and start it immediately
     */
    request(request) {
        return this.build(request).start();
    }
}
//# sourceMappingURL=Server.js.map